export interface ClientAnnouncementApiResource {
  id: string;
  title: string;
  body: string;
  published_at: string;
}

export interface ClientAnnouncement {
  id: string;
  title: string;
  body: string;
  publishedAt: string;
}

export function mapApiResourceToClientAnnouncement(
  resource: ClientAnnouncementApiResource
): ClientAnnouncement {
  return {
    id: resource.id,
    title: resource.title,
    body: resource.body,
    publishedAt: resource.published_at,
  };
}
